const $ = window.jQuery; // prefer doing this then setting up browserifyShim
const $body = $('body');
const $hiddenNav = $('.hidden-nav');
const $headerTrigger = $('.header__trigger');
const $hiddenNavHide = $('.hidden-nav__hide');
const $a = $hiddenNav.find('nav a');
const $homeNavA = $('.home-page__nav a');

const SQUIGGLES_VIEWBOX = '0 0 182 42.281';
const SQUIGGLES_FILE = `${window.THEME_CONFIG.themeRoot}/public/img/svgSprites/squiggles.svg`;
const squiggleTypes = ['blue', 'green', 'pink', 'purple', 'yellow'];
const squiggleData = [];
let isOpen = false;

 // ajax in squiggles and then append to menu items
$.get(SQUIGGLES_FILE)
	.done((res) => {
		const $doc = $(res);
		const appendSvg = function (arrayOfElements) {
			let i = 0;
			const loop = function () {
				const $this = $(this);
				const $svg = $('<svg viewBox="0 0 0 0"></svg>');// set viewBox here as otherwise would not set correctly
				const { key, viewbox, html } = squiggleData[i];

				$svg.html(html);
				$svg[0].setAttribute('viewBox', viewbox);
				// $svg.attr('viewBox', viewbox);

				$this.prepend($svg);

				if (i === squiggleData.length - 1) i = 0;
				else i++;
			};

			arrayOfElements.each(loop);

		};

		$doc.find('symbol').each(function() {
			const $symbol = $(this);
			const key = $symbol.attr('id');
			const viewbox = $symbol.attr('viewBox');
			const html = $symbol.html();

			squiggleData.push({
				key,
				viewbox,
				html,
			});

		});

		appendSvg($a);
		appendSvg($homeNavA);


		$a.each(function() {
			$(this).find('svg').css('z-index', 1);
		});

		// requestAnimationFrame(() => {
		// 	$a.each(function() {
		// 		$(this).find('svg')[0].style.opacity = '';
		// 	});
		// });

	});

const close = () => {
	$hiddenNav.removeClass('hidden-nav--open');
	$body.removeClass('hidden-nav-open');
};

const toggleClassName = () => {
	$hiddenNav.toggleClass('hidden-nav--open');
	if ($hiddenNav.hasClass('hidden-nav--open')) {
		$body.addClass('hidden-nav-open');
		isOpen = true;
	} else {
		$body.removeClass('hidden-nav-open');
		isOpen = false;
	}
};

$body.on('click', (e) => {
	const $target = $(e.target);
	if (window.matchMedia('(min-width: 75em)').matches) {
		// sorry for the long line
		if (!($target.is($hiddenNav) || $target.parents('.hidden-nav').length !== 0 || $target.is($headerTrigger) || $target.parents('.header__trigger').length !== 0)) close();
	}
});

$hiddenNavHide.on('click', toggleClassName);
$headerTrigger.on('click', toggleClassName);
